var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgHelp = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27.91,
    height: 27.91,
    viewBox: "0 0 27.91 27.91",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M550.913,530.664H553.7v-2.791h-2.791Zm1.4-22.328a13.955,13.955,0,1,0,13.955,13.955A13.96,13.96,0,0,0,552.308,508.336Zm0,25.119a11.164,11.164,0,1,1,11.164-11.164A11.179,11.179,0,0,1,552.308,533.455Zm0-19.537a5.581,5.581,0,0,0-5.582,5.582h2.791a2.791,2.791,0,0,1,5.582,0c0,2.791-4.187,2.442-4.187,6.978H553.7c0-3.14,4.187-3.489,4.187-6.978A5.581,5.581,0,0,0,552.308,513.918Z",
    transform: "translate(-538.353 -508.336)"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgHelp, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/help.071e27b0.svg";
export { ForwardRef as ReactComponent };